
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"30","viewBox":"0 0 46 30","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 .093h45.455v29.815H0V.093z","fill":"#D80027"}}),_c('path',{attrs:{"d":"M12.376 6.32l-3.704.004-.01.005.006-.01L7.536 2.65 6.53 6.324l-3.67-.005 3.048 2.155h.018l-.035.026-1.24 3.652 2.961-2.293.006-.017.006.017 2.958 2.293L9.342 8.5l-.032-.026h.011l3.055-2.155zM18.681 12.212h-.758l-.232-.748-.206.748h-.747l.622.442h.005l-.007.006-.255.746.604-.468.002-.004v.004l.606.468-.256-.746-.007-.006h.005l.625-.442zM14.495 16.1l-.022-.788-.4.66-.718-.22.48.604.002.002-.007.001-.443.642.704-.27.003-.004v.005l.452.625-.041-.79-.002-.003.717-.243-.725-.222zM17.441 8.347l.75-.037.005-.003-.002.005.253.74.185-.768-.003-.007.003.001.753-.001-.631-.439h-.003l.003-.003.206-.757-.57.503-.62-.436.282.729h-.004l-.607.473zM16.674 3.815l.006.001.717-.231-.723-.229-.003.002.003-.005-.013-.787-.406.657-.716-.23.473.609.006.001-.012.005-.447.633.706-.263.003-.004v.004l.446.635-.034-.79-.006-.008z","fill":"#FFDA44"}})])
          )
        }
      }
    